export default __webpack_public_path__ + "assets/images/listen-icon5-8306dbf6.svg";